import { SET_BIG_NUMBERS } from './bigNumbersActions';

const initialState = {
  bigNumbers: {},
};

export default function bigNumbersReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case SET_BIG_NUMBERS:
      return { ...state, bigNumbers: payload };
    default:
      return state;
  }
}
